/* AUREMAR Room Visualizer, vanilla port of the storefront studio.

   The customer uploads a photo of their room; the chosen piece is composited on
   top as a transparent cutout they can drag, scale, rotate and tilt, with a
   generated contact shadow that follows a light-direction control.

   Everything runs on the device: the photo is never uploaded anywhere. */
(function () {
  'use strict';

  var root = document.getElementById('AuremarVisualizer');
  if (!root) return;

  var PIECES = JSON.parse(document.getElementById('VisualizerData').textContent);
  if (!PIECES.length) return;

  var DEFAULT = {
    x: 0.5, y: 0.82, scale: 0.42, rotate: 0,
    // Turn around the vertical axis. A single photograph cannot show the far
    // side, so the piece narrows as it turns and mirrors past 90 degrees.
    turn: 0,
    light: 12, shadow: 0.5, shadowLength: 0.55, bright: 1
  };
  // How far the silhouette is flattened into the floor to read as a shadow.
  var SHADOW_FLATTEN = 0.5;
  var state = Object.assign({}, DEFAULT);
  var flip = false;
  var room = null;

  var params = new URLSearchParams(window.location.search);
  var piece = PIECES.find(function (p) { return p.handle === params.get('product'); }) || PIECES[0];
  var marble =
    (piece.marbles || []).find(function (m) { return m.name === params.get('marble'); }) ||
    (piece.marbles || [])[0];

  var stage = root.querySelector('.viz__stage');
  var canvas = root.querySelector('.viz__canvas');
  var zoomBar = root.querySelector('.viz__zoom');
  var zoomReadout = root.querySelector('[data-zoom-readout]');
  var pieceEl = root.querySelector('.viz__piece');
  var pieceImg = pieceEl.querySelector('img');
  var castEl = root.querySelector('.viz__cast');
  var roomPick = root.querySelector('[data-room-pick]');
  var roomThumb = root.querySelector('[data-room-thumb]');
  var roomClear = root.querySelector('[data-room-clear]');
  var roomImg = root.querySelector('img.room');
  var empty = root.querySelector('.viz__empty');
  var hint = root.querySelector('.viz__hint');
  var dropzone = root.querySelector('.dropzone');
  var pieceRow = root.querySelector('[data-pieces]');
  var marbleRow = root.querySelector('[data-marbles]');
  var downloadBtn = root.querySelector('[data-download]');
  var productLink = root.querySelector('[data-product-link]');

  /* ------------------------------------------------------------- chrome */

  function renderPieces() {
    pieceRow.innerHTML = '';
    PIECES.forEach(function (p) {
      var b = document.createElement('button');
      b.className = 'pill' + (p.handle === piece.handle ? ' active' : '');
      b.textContent = p.title;
      b.addEventListener('click', function () {
        piece = p;
        marble = (p.marbles || [])[0];
        renderPieces();
        renderMarbles();
        paint();
      });
      pieceRow.appendChild(b);
    });
    if (productLink) {
      productLink.href = piece.url;
      productLink.textContent = 'View ' + piece.title;
    }
  }

  function renderMarbles() {
    marbleRow.innerHTML = '';
    (piece.marbles || []).forEach(function (m) {
      var b = document.createElement('button');
      b.className = 'pill' + (marble && m.name === marble.name ? ' active' : '');
      b.textContent = m.name;
      b.addEventListener('click', function () {
        marble = m;
        renderMarbles();
        paint();
      });
      marbleRow.appendChild(b);
    });
  }

  /* ------------------------------------------------------------- upload */

  function loadFile(file) {
    if (!file || file.type.indexOf('image/') !== 0) return;
    var reader = new FileReader();
    reader.onload = function () {
      room = reader.result;
      state = Object.assign({}, DEFAULT);
      syncSliders();
      paint();
    };
    reader.readAsDataURL(file);
  }

  root.querySelectorAll('input[type=file]').forEach(function (input) {
    input.addEventListener('change', function () { loadFile(input.files[0]); });
  });
  var cameraBtn = root.querySelector('[data-camera]');
  if (cameraBtn) {
    cameraBtn.addEventListener('click', function () {
      if (window.AuremarCamera) window.AuremarCamera.open(loadFile);
    });
  }

  dropzone.addEventListener('dragover', function (e) { e.preventDefault(); });
  dropzone.addEventListener('drop', function (e) {
    e.preventDefault();
    loadFile(e.dataTransfer.files[0]);
  });

  /* --------------------------------------------------------------- drag */

  var dragOffset = null;

  // The piece is measured against the transformed canvas, so zoom and pan need
  // no correction of their own, the transformed bounding box carries them.
  pieceEl.addEventListener('pointerdown', function (e) {
    e.stopPropagation();
    var r = canvas.getBoundingClientRect();
    dragOffset = {
      dx: (e.clientX - r.left) / r.width - state.x,
      dy: (e.clientY - r.top) / r.height - state.y
    };
    pieceEl.classList.add('dragging');
    pieceEl.setPointerCapture(e.pointerId);
  });

  stage.addEventListener('pointermove', function (e) {
    if (dragOffset) {
      var r = canvas.getBoundingClientRect();
      state.x = clamp((e.clientX - r.left) / r.width - dragOffset.dx, -0.15, 1.15);
      state.y = clamp((e.clientY - r.top) / r.height - dragOffset.dy, 0.05, 1.2);
      paint();
      return;
    }
    if (panFrom) {
      view.px = panFrom.ox + (e.clientX - panFrom.x);
      view.py = panFrom.oy + (e.clientY - panFrom.y);
      clampPan();
      applyView();
    }
  });

  /* --------------------------------------------------------- zoom / pan */

  var view = { zoom: 1, px: 0, py: 0 };
  var panFrom = null;
  var MIN_ZOOM = 1;
  var MAX_ZOOM = 5;

  function clampPan() {
    var r = stage.getBoundingClientRect();
    var maxX = (r.width * (view.zoom - 1)) / 2;
    var maxY = (r.height * (view.zoom - 1)) / 2;
    view.px = clamp(view.px, -maxX, maxX);
    view.py = clamp(view.py, -maxY, maxY);
  }

  function applyView() {
    canvas.style.transform =
      'translate(' + view.px + 'px, ' + view.py + 'px) scale(' + view.zoom + ')';
    canvas.style.cursor = view.zoom > 1 ? (panFrom ? 'grabbing' : 'grab') : 'default';
    canvas.classList.toggle('panning', Boolean(panFrom));
    if (zoomReadout) zoomReadout.textContent = Math.round(view.zoom * 100) + '%';
    if (hint) {
      hint.textContent =
        view.zoom > 1
          ? 'Drag the piece · drag the photo to pan · scroll to zoom'
          : 'Drag the piece · scroll to zoom · sliders to match the room';
    }
  }

  function zoomTo(next) {
    view.zoom = clamp(Math.round(next * 100) / 100, MIN_ZOOM, MAX_ZOOM);
    clampPan();
    applyView();
  }

  function resetView() {
    view = { zoom: 1, px: 0, py: 0 };
    applyView();
  }

  canvas.addEventListener('pointerdown', function (e) {
    if (view.zoom <= 1 || !room) return;
    panFrom = { ox: view.px, oy: view.py, x: e.clientX, y: e.clientY };
    canvas.setPointerCapture(e.pointerId);
    applyView();
  });

  // Non-passive, so zooming the stage does not scroll the page underneath it.
  stage.addEventListener('wheel', function (e) {
    if (!room) return;
    e.preventDefault();
    zoomTo(view.zoom * (e.deltaY > 0 ? 0.9 : 1.1));
  }, { passive: false });

  var zoomIn = root.querySelector('[data-zoom-in]');
  var zoomOut = root.querySelector('[data-zoom-out]');
  var zoomReset = root.querySelector('[data-zoom-reset]');
  if (zoomIn) zoomIn.addEventListener('click', function () { zoomTo(view.zoom + 0.25); });
  if (zoomOut) zoomOut.addEventListener('click', function () { zoomTo(view.zoom - 0.25); });
  if (zoomReset) zoomReset.addEventListener('click', resetView);

  if (roomClear) {
    roomClear.addEventListener('click', function () {
      room = null;
      root.querySelectorAll('input[type=file]').forEach(function (i) { i.value = ''; });
      resetView();
      paint();
    });
  }

  ['pointerup', 'pointercancel'].forEach(function (ev) {
    stage.addEventListener(ev, function () {
      dragOffset = null;
      panFrom = null;
      pieceEl.classList.remove('dragging');
      applyView();
    });
  });

  /* ----------------------------------------------------------- controls */

  root.querySelectorAll('[data-control]').forEach(function (input) {
    input.addEventListener('input', function () {
      var key = input.dataset.control;
      var n = Number(input.value);
      if (key === 'scale' || key === 'shadow' || key === 'bright' || key === 'shadowLength') {
        state[key] = n / 100;
      } else {
        state[key] = n;
      }
      paint();
    });
  });

  var mirrorBtn = root.querySelector('[data-mirror]');
  if (mirrorBtn) {
    mirrorBtn.addEventListener('click', function () {
      flip = !flip;
      paint();
    });
  }

  var resetBtn = root.querySelector('[data-reset]');
  // Rotation is no longer offered: the piece stays level and is turned instead.
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      state = Object.assign({}, DEFAULT);
      flip = false;
      resetView();
      syncSliders();
      paint();
    });
  }

  function syncSliders() {
    root.querySelectorAll('[data-control]').forEach(function (input) {
      var key = input.dataset.control;
      input.value =
        key === 'scale' || key === 'shadow' || key === 'bright' || key === 'shadowLength'
          ? Math.round(state[key] * 100)
          : state[key];
    });
  }

/* ------------------------------------------------- advanced options */

  var advanced = root.querySelector('[data-advanced]');
  var advToggle = root.querySelector('[data-advanced-toggle]');
  if (advToggle && advanced) {
    var advBody = advanced.querySelector('.advanced__body');
    advToggle.addEventListener('click', function () {
      var open = advBody.hidden;
      advBody.hidden = !open;
      advanced.classList.toggle('is-open', open);
      advToggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* -------------------------------------------------------------- paint */

  function facing() {
    var cos = Math.cos((state.turn * Math.PI) / 180);
    return (cos < 0 ? -1 : 1) * (flip ? -1 : 1) * Math.max(0.12, Math.abs(cos));
  }

  function paint() {
    var hasRoom = Boolean(room);
    var cutout = marble && marble.cutout;

    roomImg.hidden = !hasRoom;
    if (hasRoom) roomImg.src = room;
    // Nothing worth pinning until there is a photo on the stage, so the empty
    // stage scrolls away with the rest of the page.
    if (stage) stage.classList.toggle('is-pinned', hasRoom);
    if (roomPick) {
      roomPick.hidden = !hasRoom;
      if (hasRoom && roomThumb) roomThumb.src = room;
    }
    empty.hidden = hasRoom;
    hint.hidden = !hasRoom;
    if (zoomBar) zoomBar.hidden = !hasRoom;
    pieceEl.hidden = !(hasRoom && cutout);
    castEl.hidden = !(hasRoom && cutout);
    downloadBtn.disabled = !(hasRoom && cutout);

    if (!cutout) return;
    pieceImg.src = cutout;
    pieceImg.alt = piece.title + ' in ' + marble.name;
    pieceImg.style.filter = 'brightness(' + state.bright + ')';

    var face = facing();
    var box =
      'left:' + state.x * 100 + '%;top:' + state.y * 100 + '%;height:' + state.scale * 100 + '%;width:auto;';

    pieceEl.style.cssText = box +
      'transform: translate(-50%, -100%) rotate(' + state.rotate + 'deg) scaleX(' + face + ');';

    // The shadow is the piece's own silhouette lying on the floor: anchored at
    // the base, flattened into the ground plane and sheared toward the light.
    castEl.src = cutout;
    castEl.style.cssText = box +
      'opacity:' + state.shadow + ';' +
      'transform: translate(-50%, -100%) rotate(' + state.rotate + 'deg)' +
      ' skewX(' + -state.light * 1.25 + 'deg)' +
      ' scaleX(' + face + ')' +
      ' scaleY(' + state.shadowLength * SHADOW_FLATTEN + ');';

    root.querySelectorAll('[data-readout]').forEach(function (el) {
      var key = el.dataset.readout;
      if (key === 'scale' || key === 'shadow' || key === 'bright' || key === 'shadowLength') {
        el.textContent = Math.round(state[key] * 100) + '%';
      } else {
        el.textContent = state[key] + '°';
      }
    });
  }

  /* ----------------------------------------------------------- download */

  downloadBtn.addEventListener('click', function () {
    if (!room || !marble || !marble.cutout) return;
    downloadBtn.disabled = true;
    var label = downloadBtn.textContent;
    downloadBtn.textContent = 'Rendering…';

    Promise.all([loadImage(room), loadImage(marble.cutout)])
      .then(function (imgs) {
        var bg = imgs[0];
        var art = imgs[1];
        var canvas = document.createElement('canvas');
        canvas.width = bg.naturalWidth;
        canvas.height = bg.naturalHeight;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(bg, 0, 0);

        // Mirror the on-screen transform exactly, so the file that downloads is
        // the arrangement the customer was just looking at.
        var h = state.scale * canvas.height;
        var w = (art.naturalWidth / art.naturalHeight) * h;
        var cx = state.x * canvas.width;
        var cy = state.y * canvas.height;
        var rot = (state.rotate * Math.PI) / 180;
        var face = facing();

        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(rot);
        ctx.globalAlpha = state.shadow;
        ctx.filter = 'blur(' + Math.max(3, h * 0.02) + 'px) brightness(0) saturate(0)';
        ctx.transform(1, 0, Math.tan((-state.light * 1.25 * Math.PI) / 180), 1, 0, 0);
        ctx.scale(face, state.shadowLength * SHADOW_FLATTEN);
        ctx.drawImage(art, -w / 2, -h, w, h);
        ctx.restore();

        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(rot);
        ctx.scale(face, 1);
        ctx.filter = 'brightness(' + state.bright + ')';
        ctx.drawImage(art, -w / 2, -h, w, h);
        ctx.restore();

        var a = document.createElement('a');
        a.download = 'auremar-' + piece.handle + '-in-your-room.jpg';
        a.href = canvas.toDataURL('image/jpeg', 0.92);
        a.click();
      })
      .catch(function () { /* leave the on-screen preview untouched */ })
      .finally(function () {
        downloadBtn.disabled = false;
        downloadBtn.textContent = label;
      });
  });

  /* -------------------------------------------------------------- utils */

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function clamp(n, lo, hi) {
    return Math.min(hi, Math.max(lo, n));
  }

  renderPieces();
  renderMarbles();
  syncSliders();
  applyView();
  paint();
})();
